import { useState } from "react";
import styled from "styled-components";
import css from "@styled-system/css";
import { layout, LayoutProps } from "styled-system";

import Icon from "../Icon/Icon";

import { MyBCALinks } from "./bcaHeader.type";
import MyBCAPopover from "./MyBCAPopover";

const MyBCAButton = styled.a`
  text-decoration: none;
  position: relative;
  display: flex;
  flex-direction: column;
  align-items: center;
  margin-top: 2px;
  line-height: 24px;
  ${css({
    color: "primary-white",
    fontSize: "body",
    fontFamily: "normal",
    fontWeight: "semiBold",
  })}
`;

const Div = styled.div<LayoutProps>`
  position: relative;
  &:hover ul {
    visibility: visible;
  }
  &:focus-within ul {
    visibility: visible;
  }
  ${layout}
`;

interface MyBCAProps extends LayoutProps {
  links: MyBCALinks;
  logOutUrl: string;
  user?: { firstName: string; lastName: string };
  myBCALink?: string;
}

export default function MyBCA({
  logOutUrl,
  links,
  user,
  myBCALink = "https://www.bca.co.uk/MyBCA/",
  ...props
}: MyBCAProps) {
  const [isSelected, setIsSelected] = useState(false);

  return (
    <Div
      {...props}
      onMouseEnter={() => setIsSelected(true)}
      onMouseLeave={() => setIsSelected(false)}
      onFocus={() => setIsSelected(true)}
      onBlur={() => setIsSelected(false)}
    >
      <MyBCAButton href={myBCALink}>
        <Icon
          name="user-alt"
          weight={isSelected ? "solid" : "light"}
          color="primary-white"
          height={26}
          width={26}
        />
        MyBCA
      </MyBCAButton>
      <MyBCAPopover
        links={links}
        logOutUrl={logOutUrl}
        user={user}
        isVisible={isSelected}
      ></MyBCAPopover>
    </Div>
  );
}
